import {Component, Input} from '@angular/core';
import {Unit} from '../../dashboard/monitoring/unit';
import {UnitCardIndicatorsComponent} from '../unit-card-indicators/unit-card-indicators.component';

@Component({
  selector: 'app-unit-car-indicators',
  templateUrl: './unit-car-indicators.component.html',
})
export class UnitCarIndicatorsComponent extends UnitCardIndicatorsComponent {

  @Input() set unit(unit: Unit) {
    this.indicators = [
      this.chargeIndicator(unit),
      this.protectIndicator(unit),
      this.lockIndicator(unit),
      this.brakeIsOnIndicator(unit),
      {
        title: this.translates.instant(
          this.caseNullOrTrueOrFalse(unit, 'ignition', 'On', 'Off', 'n/i')
        ),
        iconClass: 'icon icon-ignition' +
          this.caseNullOrTrueOrFalse(unit, 'ignition', ' on', ' off', ' inactive'),
        value: this.translates.instant(
          this.caseNullOrTrueOrFalse(unit, 'ignition', 'On', 'Off', 'n/i')
        ),
        isVisible: this.isValueDefined(unit.lastMsgUnit) && this.isValueDefined(unit.lastMsgUnit.ignition) ,
      },
      {
        title: this.translates.instant(
          this.caseNullOrTrueOrFalse(unit, 'engine_is_on', 'On', 'Off', 'n/i')
        ),
        iconClass: 'icon icon-engine' +
          this.caseNullOrTrueOrFalse(unit, 'engine_is_on', ' on', ' off', ' inactive'),
        value: this.translates.instant(
          this.caseNullOrTrueOrFalse(unit, 'engine_is_on', 'On', 'Off', 'n/i')
        ),
        isVisible: this.isValueDefined(unit.lastMsgUnit) && this.isValueDefined(unit.lastMsgUnit.engine_is_on) ,
      },
      this.voltageIndicator(unit),
      this.speedIndicator(unit)
    ];
  }
}
